import getLiveDocument from './get-live-document';
import constants from '../../blocks/constants/common';

const getPageBlocks = () => {
  const liveDocument = getLiveDocument();
  const blocks = liveDocument.querySelectorAll(`[id^='${constants.BLOCK_ID_PREFIX}']`);
  return [...blocks];
};

export default getPageBlocks;
